import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p485762421098745856',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
